import { render, staticRenderFns } from "./GradesStudentList.vue?vue&type=template&id=ff614748"
import script from "./GradesStudentList.js?vue&type=script&lang=js&external"
export * from "./GradesStudentList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports